import { Position, State } from 'src/types'
import { flatWeb } from 'src/features/gorilla/drawer/glove/rightThrow/front/web/flatWeb'
import { crossJointWeb, crossWeb, crossWebCenterStitch } from 'src/features/gorilla/drawer/glove/rightThrow/front/web/crossWeb'
import { onePeaceWeb } from 'src/features/gorilla/drawer/glove/rightThrow/front/web/onPeaceWeb'
import { vWeb } from 'src/features/gorilla/drawer/glove/rightThrow/front/web/vWeb'
import { laceOfcrossWebWithHalfNet, laceOfNetWeb } from 'src/features/gorilla/drawer/glove/rightThrow/front/web/netWeb'
import { netWeb2 } from 'src/features/gorilla/drawer/glove/rightThrow/front/web/netWeb2'
import { laceOfNetWebDouble, netWebDouble } from 'src/features/gorilla/drawer/glove/rightThrow/front/web/netWebDouble'
import { crossDoubleWeb } from 'src/features/gorilla/drawer/glove/rightThrow/front/web/crossDoubleWeb'
import { basketForPitcherWeb } from 'src/features/gorilla/drawer/glove/rightThrow/front/web/basketWeb'
import { hJointWeb, hWeb } from 'src/features/gorilla/drawer/glove/rightThrow/front/web/hWeb'
import {
  underWeb,
  underWebForNetWeb1,
  underWebForNetWeb2,
  underWebReinforcement
} from 'src/features/gorilla/drawer/glove/rightThrow/front/lace/underWeb'
import { fenceWeb } from 'src/features/gorilla/drawer/glove/rightThrow/front/web/fenceWeb'
import { crossWebWithHalfNetLace } from 'src/features/gorilla/drawer/glove/rightThrow/front/web/crossWebWithHalfLaceWeb'
import { jointCheckerWeb } from 'src/features/gorilla/drawer/glove/rightThrow/front/web/jointCheckerWeb'
import { netVWeb } from 'src/features/gorilla/drawer/glove/rightThrow/front/web/netVWeb'
import { lacingNetWeb } from 'src/features/gorilla/drawer/glove/rightThrow/front/web/lacingNetWeb'
import { lacingCrownNetWeb } from 'src/features/gorilla/drawer/glove/rightThrow/front/web/lacingCrownNetWeb'
import { hWeb2 } from 'src/features/gorilla/drawer/glove/rightThrow/front/web/hWeb2'
import { onePeaceWeb2 } from 'src/features/gorilla/drawer/glove/rightThrow/front/web/onePeaceWeb2'
import { laceOfNetWeb2, lacingWeb1 } from 'src/features/gorilla/drawer/glove/rightThrow/front/web/lacingWeb1'
import { laceOfNetWebDoubleWithJoint } from 'src/features/gorilla/drawer/glove/rightThrow/front/web/newWebDoubleWithJoint'
import { indexWrapBack } from 'src/features/gorilla/drawer/glove/rightThrow/front/lace/connectIndexToWeb'
import { twoPeaceVDesignWeb } from 'src/features/gorilla/drawer/glove/rightThrow/front/web/twoPeaceVDesignWeb'
import { w1Web } from 'src/features/gorilla/drawer/glove/rightThrow/front/web/w1Web'
import { w2Web } from 'src/features/gorilla/drawer/glove/rightThrow/front/web/w2Web'
import { flatVLaceWeb } from 'src/features/gorilla/drawer/glove/rightThrow/front/web/flatVLaceWeb'
import { netWeb3 } from 'src/features/gorilla/drawer/glove/rightThrow/front/web/netWeb3'
import { bomberOriginalWeb } from 'src/features/gorilla/drawer/glove/rightThrow/front/web/bomberOriginalWeb'
import { bomberOriginalReverseWeb } from 'src/features/gorilla/drawer/glove/rightThrow/front/web/bomberOriginalReverseWeb'
import { w32Web } from 'src/features/atoms/glove/drawer/rightThrow/glove/front/web/w32Web'
import { w34Web } from 'src/features/atoms/glove/drawer/rightThrow/glove/front/web/w34Web'
import { w35Web } from 'src/features/atoms/glove/drawer/rightThrow/glove/front/web/w35Web'
import { w36Web } from 'src/features/atoms/glove/drawer/rightThrow/glove/front/web/w36Web'
import { webDrawUtil } from 'src/util/canvas'
import { positionChecker } from 'src/logic'

export const webOfGloveFrontDrawer = (ctx: CanvasRenderingContext2D, state: State, position: Position): void => {
  const { webMatcher, webColor, web2Color, laceColor, stitchColor, edgeColor, productNumber } = webDrawUtil(state)
  if (webMatcher(['w1'])) w1Web(ctx, webColor, laceColor, stitchColor)
  if (webMatcher(['w3'])) basketForPitcherWeb(ctx, webColor, laceColor, stitchColor)
  if (webMatcher(['w4'])) flatVLaceWeb(ctx, webColor, laceColor, stitchColor)
  if (webMatcher(['w5'])) flatWeb(ctx, webColor, laceColor, stitchColor)
  if (webMatcher(['w6', 'w22', 'w29'])) crossWebCenterStitch(ctx, webColor, laceColor, stitchColor)
  if (webMatcher(['w8', 'w10'])) crossWeb(ctx, webColor, laceColor, stitchColor)
  if (webMatcher(['w9'])) hWeb2(ctx, webColor, laceColor, stitchColor)
  if (webMatcher(['w11'])) hWeb(ctx, webColor, laceColor, stitchColor)
  if (webMatcher(['w13'])) lacingNetWeb(ctx, webColor, laceColor, stitchColor)
  if (webMatcher(['w14'])) netWeb3(ctx, webColor, edgeColor, laceColor, stitchColor)
  if (webMatcher(['w33'])) netWebDouble(ctx, laceColor, stitchColor, webColor, web2Color)
  if (webMatcher(['w17'])) netWeb2(ctx, webColor, edgeColor, laceColor, stitchColor)
  if (webMatcher(['w19'])) crossDoubleWeb(ctx, webColor, laceColor, stitchColor)
  if (webMatcher(['w20'])) netVWeb(ctx, webColor, laceColor, stitchColor)
  if (webMatcher(['w23'])) fenceWeb(ctx, webColor, laceColor, stitchColor)
  if (webMatcher(['w24'])) onePeaceWeb(ctx, webColor, laceColor, stitchColor)
  if (webMatcher(['w25'])) netWebDouble(ctx, webColor, edgeColor, laceColor, stitchColor)
  if (webMatcher(['w26'])) jointCheckerWeb(ctx, webColor, web2Color, laceColor, stitchColor)
  if (webMatcher(['w27'])) hJointWeb(ctx, webColor, laceColor, stitchColor)
  if (webMatcher(['w28'])) crossJointWeb(ctx, webColor, laceColor, stitchColor)
  if (webMatcher(['w30'])) vWeb(ctx, webColor, laceColor, stitchColor)
  if (webMatcher(['w32'])) w32Web(ctx, edgeColor, laceColor, stitchColor, webColor, web2Color)
  if (webMatcher(['w34'])) w34Web(ctx, laceColor, stitchColor, webColor, web2Color)
  if (webMatcher(['w36'])) w36Web(ctx, edgeColor, laceColor, stitchColor, webColor, web2Color)
  const { isPitcher } = positionChecker(position)
  const isBomber = state.series?.value === 'bomber' && isPitcher
  const is001Model = productNumber === '001-20'
  const condBomberWeb = isBomber && !is001Model
  if (condBomberWeb) bomberOriginalWeb(ctx, webColor, laceColor, stitchColor)
  const condBomberReverseWeb = isBomber && is001Model
  if (condBomberReverseWeb) bomberOriginalReverseWeb(ctx, webColor, laceColor, stitchColor)
}

export const rightLaceOfNetWebDrawer = (ctx: CanvasRenderingContext2D, state: State): void => {
  const { webMatcher, webColor, laceColor, stitchColor, productNumber } = webDrawUtil(state)
  if (webMatcher(['w14', 'w17', 'w20'])) laceOfNetWeb(ctx, laceColor)
  const condIsNetWeb = webMatcher(['w14', 'w17'])
  if (condIsNetWeb) {
    underWeb(ctx, laceColor, 10, 0) // ウェブ下＿右
    underWeb(ctx, laceColor, -32, 64) // ウェブ下＿左
    indexWrapBack(ctx, laceColor, -10, -100) // 上
  }
  const condIsNetDoubleWeb = webMatcher(['w25', 'w33'])
  if (condIsNetDoubleWeb) {
    laceOfNetWebDouble(ctx, webColor, laceColor, stitchColor)
    underWebForNetWeb1(ctx, laceColor, 0, 0)
    underWebForNetWeb1(ctx, laceColor, -17, 30)
    underWebForNetWeb2(ctx, laceColor, -133, 95, -20)
    underWebForNetWeb2(ctx, laceColor, -15, 28, 0)
  }
  if (!condIsNetWeb && !condIsNetDoubleWeb) {
    underWeb(ctx, laceColor, 27, -24) // ウェブ下＿右
    underWeb(ctx, laceColor, -2, 28) // ウェブ下＿中
    underWeb(ctx, laceColor, -35, 72) // ウェブ下＿左
    indexWrapBack(ctx, laceColor, -10, -100) // 上
    indexWrapBack(ctx, laceColor, -4, -40) // 中
    indexWrapBack(ctx, laceColor, 3, 20) // 下
  }
  if (webMatcher(['w25'])) laceOfNetWebDoubleWithJoint(ctx, webColor, laceColor, stitchColor)
  if (webMatcher(['w36'])) laceOfNetWebDouble(ctx, webColor, laceColor, stitchColor)
  if (productNumber === '006') underWebReinforcement(ctx, laceColor)
}
